import {createStore, applyMiddleware, compose} from 'redux'
import thunkMiddleware from 'redux-thunk'
import rootReducer from './reducers/index'

let _middleware = [
	thunkMiddleware
];

const configureStore = preloadedState =>
{
	return createStore(
			rootReducer,
			preloadedState,
			compose(applyMiddleware(..._middleware))
	)
}

export default configureStore